var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAscend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37694 4.50305L5.50675 8.37324C5.50675 8.37324 5.4896 8.3801 5.48275 8.37324L4.1178 7.0083C4.1178 7.0083 4.10066 7.00144 4.0938 7.0083L0.0504159 11.0517C-0.0576134 11.1597 0.0195495 11.3449 0.172162 11.3449H15.8278C15.9804 11.3449 16.0576 11.1597 15.9496 11.0517L9.40095 4.50305C9.40095 4.50305 9.3838 4.49619 9.37694 4.50305ZM3.21584 10.6573H1.45651C1.44108 10.6573 1.43422 10.6384 1.44451 10.6281L4.09551 7.97713C4.09551 7.97713 4.11266 7.97027 4.11952 7.97713L5.01119 8.8688L3.22956 10.6504C3.22956 10.6504 3.2227 10.6556 3.21756 10.6556L3.21584 10.6573ZM11.4484 9.08315C11.3609 9.08315 11.2735 9.04885 11.2066 8.98198L9.40267 7.17806C9.40267 7.17806 9.38552 7.1712 9.37866 7.17806L7.57474 8.98198C7.42727 9.12945 7.18035 9.11401 7.05174 8.93739C6.95229 8.7985 6.98144 8.60473 7.10147 8.48298L9.37694 6.20751C9.37694 6.20751 9.39409 6.20065 9.40095 6.20751L11.673 8.48127C11.8016 8.60988 11.8256 8.82251 11.7073 8.9614C11.6387 9.04199 11.5427 9.08143 11.4466 9.08143L11.4484 9.08315Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAscend);
export default __webpack_public_path__ + "static/media/IconAscend.8752d162dad694a0cda3bcef72ec6ce7.svg";
export { ForwardRef as ReactComponent };